/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Ad_JobInputs */



/**
* | output |
* | --- |
* | "Automatic AD/DV Job" |
*
* @param {Automatic_Ad_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_ad_job = /** @type {((inputs?: Automatic_Ad_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Ad_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Emploi de publicité automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatischer AD-Job")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavoro AD automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое задание AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajo automático de AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动广告作业")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動ADジョブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित एडी जॉब")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tarefa de anúncio automática")
	return /** @type {LocalizedString} */ ("Automatic AD/DV Job")
});